import React from 'react';
import { Heading, Image, Text } from '@dotcom/crown-ui';
import { InstructionStepProps } from '../wam-instructions-drawer-types';
import styles from '../wam-instructions-drawer.module.scss';

export const InstructionStep = ({ title, text, imageUrl, stepNumber }: InstructionStepProps) => {
  return (
    <div className={styles['instruction-step']}>
      <div className={styles['instruction-image-wrapper']}>
        <Image src={imageUrl} className={styles['instruction-image']} alt="" />
        <Text as="span" styleVariant="caption" className={styles['badge']}>
          {stepNumber}
        </Text>
      </div>
      <div className={styles['instruction-text']}>
        <Heading as="h2" className={styles['step-title']} styleVariant="subtitle" color="textPrimary">
          {title}
        </Heading>
        <Text className={styles['step-description']}>{text}</Text>
      </div>
    </div>
  );
};
